module.exports = __webpack_public_path__ + "img/shaun.0514e354.png";